import React, { useState, useEffect, useRef } from 'react';
import Ansi from "../../lib/ansi2react";
import dataProvider from '../../lib/dataProvider';
import isTest from '../../lib/isTest'
import { setGlobalData, getGlobalData } from '../../lib/globalData';

import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';
import KeyboardDoubleArrowDown from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import ReplayIcon from '@mui/icons-material/Replay';

const GlobServer = () => {
  const [versionlist, setVersionlist] = useState([]);
  const [version, setVersion] = useState(false);
  const [textid, setTextId] = useState({id: false, pos: -1, retry: 0});
  const [text, setText] = useState('');
  const [lastCmd, setLastCmd] = useState('');
  const [autoScroll, setAutoScroll] = useState(false);
  const [cccmd, setCCcmd] = useState(localStorage.getItem('globServer.cccmd')??'unit-file web/portale/portalTest.php:dasistkeinTest');
  const [hist, setHist] = useState(JSON.parse(localStorage.getItem('globServer.hist'))??[]);
  const logFetch = useRef(false);

  const addHistory = (value) => {
    if(!hist.includes(value)){
      const h = [...hist]
      h.unshift(value)
      localStorage.setItem('globServer.hist', JSON.stringify(h));
      setHist(h)
    }
  }
  const clearHistory = () => {
    setHist([])
    localStorage.setItem('globServer.hist', JSON.stringify([]));
  }
  
  useEffect(() => {
    dataProvider.getOne('globServer', { id: 'versions' })
    .then(res  => { 
      setVersionlist(res.data);
      setVersion(0);
    })
    if(!logFetch.current && textid.id === false){
      logFetch.current = true
      dataProvider.getOne('globServer', { id: 'cmd/log' })
        .then(res  => { 
          setTextId({id: res.data.id, pos: 0, retry: 0});
          if(res.data?.info){
            updateInfo(res.data?.info)
          }
        }) 
    }
    // eslint-disable-next-line
  }, []);
    
  useEffect(() => {
    if (textid.id === false) return;
    dataProvider.getOne('globServer', { id: 'getoutput/'+textid.id+'/'+textid.pos })
    .then(res  => { 
      if (res.data.pos === textid.pos) {
        if (textid.pos>-1 && textid.retry<300) {
          setTimeout(() => {
            setTextId({id: textid.id, pos: textid.pos, retry: textid.retry+1});
          }, 1000);          
        }
      }
      else {
        setText(t => t + res.data.text);
        setTextId({id: textid.id, pos: res.data.pos, retry: 0});
      }
      if(autoScroll){
        window.scrollTo({top: document.documentElement.scrollHeight})
      }
      
    })
      // eslint-disable-next-line
  }, [textid]);
  
  const SelectList = ({text}) => {
    const bStyle = {border: 'none', backgroundColor: '#FFF'}
    const handleFileRevert = (ln) => {
      const file = encodeURI(ln.substring(1).trim()).replace(/\//g, '%09')
      setText('');
      dataProvider.getOne('globServer', { id: 'cmd/svnrevert/'+file })
        .then(res  => {
          setTextId({id: res.data.id, pos: 0, retry: 0});
        })
    }
    return (
      <div style={{fontFamily: 'monospace'}}>
        { text.split("\n").map((ln,idx) => 
          <div key={'ln'+idx} style={{display: 'flex', minHeight: '1em'}}>
            <span>{ln}</span>
            { ln.charAt(0) === 'M' && <button style={bStyle} onClick={()=>handleFileRevert(ln)}><ReplayIcon sx={{color: 'red'}} /></button> }
          </div>
        ) }
      </div>
    )
  }
  
  const versionchange = (event) => {
    setVersion(event.target.value);
  };
  
  const cccmdchange = (event) => {
    setCCcmd(event.target.value);
  };

  const updateInfo = (newinfo) => {
    const info = getGlobalData('info');
    setGlobalData({info: {...info, ...newinfo}});
    localStorage.setItem('info', JSON.stringify({...info, ...newinfo}));
  }
  
  const clickcmd = ( cmd ) => () => {
    setText('');
    setLastCmd(cmd)
    dataProvider.getOne('globServer', { id: 'cmd/'+cmd })
      .then(res  => {
        setTextId({id: res.data.id, pos: 0, retry: 0});
        if(res.data?.info){
          updateInfo(res.data?.info)
        }
      })
  }
  
  const clickupdate = () => {
    setText('');
    setLastCmd('update')
    dataProvider.getOne('globServer', { id: 'cmd/svnupdate/'+encodeURI(version).replace(/\//g, '%09') })
      .then(res  => {
        setTextId({id: res.data.id, pos: 0, retry: 0});
      })
  }
  
  const clickcc = () => {
    setText('');
    var cmd = cccmd
    setLastCmd('cccmd')
    if(cccmd.indexOf("tests/") !== -1){
      cmd = cccmd.substring(cccmd.indexOf("tests/")+6)
      if(cmd.indexOf("tests/") !== -1){ // in case the full string was posted (z_tests...)
        cmd = cmd.substring(cmd.indexOf("tests/")+6)
      }
    }
    var pos1 = cmd.indexOf('/')
    var pos2 = cmd.indexOf(' ')
    if( pos1 !== -1 && (pos2 === -1 || pos2 > pos1)){
      cmd = cmd.slice(0, pos1)+' '+cmd.slice(pos1+1)
    }
    if(cmd !== cccmd){
      setCCcmd(cmd);
    }
    addHistory(cmd)
    localStorage.setItem('globServer.cccmd',cmd)
    dataProvider.getOne('globServer', { id: 'cmd/start_cc/'+encodeURI(cmd).replace(/\//g, '%09') })
      .then(res  => {
        setTextId({id: res.data.id, pos: 0, retry: 0});
      })
  }
  
  const clickrevert = (file='file') => {
    setText('');
    dataProvider.getOne('globServer', { id: 'cmd/svnrevert/'+(file==='file'?encodeURI(cccmd).replace(/\//g, '%09'):file) })
      .then(res  => {
        setTextId({id: res.data.id, pos: 0, retry: 0});
      })
  }
  
  const clicksql = () => {
    setText('');
    setLastCmd('sql')
    dataProvider.update('globServer', { id: 'cmd/start_sql/', data: {sql: cccmd} })
      .then(res  => {
        setText(res.data.text);
        //setTextId({id: res.data.id, pos: 0, retry: 0});
      })
  }
  
  const LocalButton = (props) => ( 
    <React.Fragment>
      <Button variant="contained" color="primary" value="-" disabled={textid.pos>-1} {...props}>{props.text}</Button>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </React.Fragment>
  )
  
  return (         
    <Paper style={{scroll:'auto'}} >
      <CardContent>
      <div style={{display:'flex', justifyContent: 'space-between'}}>
        <div>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <FormControl variant="filled" style={{marginTop: '-.2em', marginBottom: 0}}>
            <InputLabel htmlFor="version">Version</InputLabel>
            <Select
              native
              value={version}
              onChange={versionchange}
              style={{minWidth: '170px'}}
              inputProps={{name: 'age',id: 'version'}}
            >
              {versionlist.map((v)=>(<option value={v.id} key={v.id}>{v.text}</option>))}
            </Select>
          </FormControl>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <LocalButton onClick={clickupdate} text="Update" />
          { isTest && <>
            <LocalButton onClick={clickcmd('svnstat')} text="Status" />
            <LocalButton onClick={clickcmd('installphp')} text="Install PHP" />
            <LocalButton onClick={clickcmd('installbwo')} text="Install BWO" />
            <LocalButton onClick={clickcmd('installadm')} text="Install Admin" />
            <LocalButton onClick={clickcmd('test')} text="Test Script" />
            <LocalButton onClick={clicksql} text="run sql on testDBs" />
          </>}
        </div>
      </div>
      { isTest && <>
        <TextField id="standard-basic" label="Test" value={cccmd} onChange={cccmdchange} fullWidth multiline />
        <LocalButton onClick={clickcc} text="Codeception" />
        <span style={{marginLeft: '10em'}}>History: </span>
        <Select value={cccmd} onChange={e=>setCCcmd(e.target.value)} size="small" variant="filled" sx={{'& .MuiSelect-filled': {pt: '0.3em'}, height: '2.5em', mr: '.7em', mt: '.2em'}}>
          {hist.map((me)=><MenuItem value={me}>{me}</MenuItem>)}
        </Select>
        <LocalButton onClick={clearHistory} text="Clear History" />
      </>}
      <br />
      { lastCmd !== 'svnstat' && <Ansi>{text}</Ansi> }
      { lastCmd === 'svnstat' && <SelectList text={text} /> }
      <br />
      { isTest && <>
        <TextField id="standard-basic" label="Test" value={cccmd} onChange={cccmdchange} fullWidth multiline />
        { lastCmd !== 'svnstat' && <LocalButton onClick={clickcc} text="Codeception" /> }
        { lastCmd === 'svnstat' && <>
          <LocalButton onClick={()=>clickrevert()} text="Revert File" />
          <LocalButton onClick={()=>clickrevert('conflict')} text="Revert Conflicts" />
          <LocalButton onClick={()=>clickrevert('all')} text="Revert All" />
        </>}
      </>}
      </CardContent>
      <div style={{display: 'grid', position: 'fixed', bottom: '0.5em', right: '0.5em'}}>
        <Button variant="contained" sx={{minWidth: 'unset', width: '2em', marginBottom: '.3em'}} disabled={autoScroll && textid.pos>-1} color="primary" value="-" onClick={()=>window.scrollTo({top: 0})}>
          <KeyboardArrowUp />
        </Button>
        <Button variant="contained" sx={{backgroundColor: autoScroll?"#2c387e":"#3f51b5", minWidth: 'unset', width: '2em', marginBottom: '.3em'}} value="-" onClick={()=>setAutoScroll(!autoScroll)}>
          <KeyboardDoubleArrowDown />
        </Button>
        <Button variant="contained" sx={{minWidth: 'unset', width: '2em'}} disabled={autoScroll && textid.pos>-1} color="primary" value="-" onClick={()=>window.scrollTo({top: document.documentElement.scrollHeight})}>
          <KeyboardArrowDown />
        </Button>
      </div>
    </Paper>         
  )
}
/*
// https://www.npmjs.com/package/ansi-to-react

*/
export default GlobServer;